import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from } from 'rxjs';
import { AuthTokenService } from './services/auth-token.service';
import { SessionService } from './services/session.service';

@Injectable()
export class MockHttpCalIInterceptor implements HttpInterceptor {
    constructor(
      private sessionService: SessionService,
      private authTokenService: AuthTokenService,
    ) {}

    private async handle(req: HttpRequest<any>, next: HttpHandler) {
      const isAuthenticated = this.sessionService.isAuthenticated

      if(!isAuthenticated) return next.handle(req.clone()).toPromise()

      const authToken = await this.authTokenService.handleGetAuthToken()

      const reqWithAuthToken = req.clone({
        headers: req.headers.set('api-token', authToken)
      });

      return next.handle(reqWithAuthToken).toPromise()
    }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (req.headers.get('No-Auth'))
            return next.handle(req.clone());

        return from(this.handle(req, next))
    }
}

